module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-9-6ec9bd1ccba484d7e6717ddc5c3b0200.svg";